<template>
  <div class="picker-box">
    <div class="picker-title">收票地址</div>
    <div class="picker-content" @click="showPicker">
      <span>{{areaName}}</span><i class="iconfont iconarrow-right"></i>
    </div>
  </div>
</template>

<script>
import Picker from 'better-picker';
import apis from 'api/index';

export default {
  data() {
    return {
      provincialList: [], // 省列表
      citiesList: [], // 室列表
      countiesList: [], // 县列表
      areaName: '请选择',
      picker: null
    }
  },
  created() {
    this.fetchAreaList(null).then(res => {
      this.provincialList = res;
      this.fetchAreaList(res[0].id).then(cityRes => {
        this.citiesList = cityRes;
        this.fetchAreaList(cityRes[0].id).then(countyRes => {
          this.countiesList = countyRes;
          this.createPicker();
        });
      });
    });
  },
  methods: {
    async fetchAreaList(id) {
      try {
        const res = await apis.getXzqhTree({id: id});
        return res.data;
      } catch(err) {
        console.error(err);
      }
    },
    createPicker() {
      this.picker = new Picker({
        data: [this.provincialList, this.citiesList, this.countiesList],
        selectedIndex: [0, 0, 0],
        title: '选择地区'
      });
      this.picker.on('picker.change', (index, selectedIndex) => {
        // 滚动省
        if(index === 0) {
          let id = this.provincialList[selectedIndex].id;
          this.fetchAreaList(id).then(res => {
            this.citiesList = res;
            this.picker.refillColumn(1, this.citiesList);
            this.fetchAreaList(res[0].id).then(countyRes => {
              this.countiesList = countyRes;
              this.picker.refillColumn(2, this.countiesList);
            });
          });
        } else if (index === 1) {
          let id = this.citiesList[selectedIndex].id;
          this.fetchAreaList(id).then(res => {
            this.countiesList = res;
            this.picker.refillColumn(2, this.countiesList);
          });
        }
      });
      this.picker.on('picker.select', (selectedVal , selectedIndex) => {
        this.areaName = this.provincialList[selectedIndex[0]].text + this.citiesList[selectedIndex[1]].text + this.countiesList[selectedIndex[2]].text;
        this.$emit('select', this.countiesList[selectedIndex[2]]);
      });
    },
    showPicker() {
      this.picker.show();
    }
  }
}
</script>

<style lang="scss" scoped>
.picker-box {
  width: 100%;
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .picker-title {
    font-size: 15px;
    color: #4d4d4d;
  }
  .picker-content {
    font-size: 15px;
  }
}
</style>